import React, { useMemo } from "react";
import { useApiData } from "../../hooks/useFetch.js";
import { api } from "../../api/api.js";
import StateGuard from "../StateGuard.jsx";
import SubventionChart from "../charts/SubventionChart.jsx";

export default function SubventionTab({
  baseParams,
  prixVente,
  tauxActu,
  polSubv,
  prixEauList,
  culture,
  libelle,
}) {
  const params = useMemo(
    () => ({
      ...baseParams,
      prix_vente: prixVente,
      taux_actu: tauxActu,
      pol_subv: polSubv,
      prix_eau: prixEauList,
    }),
    [baseParams, prixVente, tauxActu, polSubv, prixEauList]
  );

  const { data, loading, error } = useApiData(api.getSubvention, params, {
    skip: !baseParams.idProdu || !baseParams.gridno,
  });

  return (
    <div className="diagoeau-panel">
      <h3>À construire prochainement</h3>
      {/* <h3>
        Subvention — {culture} | {libelle} | {polSubv}
      </h3>
      <StateGuard
        loading={loading}
        error={error}
        empty={!data || data.length === 0}
        emptyMessage="Pas de données pour cette région / politique."
      >
        {data && (
          <>
            <SubventionChart data={data} />
            <table className="diagoeau-data-table">
              <thead>
                <tr>
                  <th>Équipement</th>
                  <th>VP marges (€)</th>
                  <th>Subvention (€)</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row) => (
                  <tr key={row.equipement}>
                    <td>{row.equipement}</td>
                    <td>{row.vp_marges.toLocaleString("fr-FR")}</td>
                    <td>{row.subvention.toLocaleString("fr-FR")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </StateGuard> */}
    </div>
  );
}